import { fr } from "date-fns/locale";
import { DayPicker } from "react-day-picker";
import "./../../../../../../node_modules/react-day-picker/dist/style.css";
import './CustomDayPicker.scss';
import moment from "moment";

moment().locale('fr');

export default function CustomDayPicker({
  month,
  monthIndex,
  selectedDays,
  onSelect,
  disabledDays,
  modifiers,
  modifiersClassNames,
  disabledDayToOpenForWork,
  setDisabledDayToOpenForWork
}) {
  let defaultModifiers = {
    weekend: { dayOfWeek: [ 0, 6, ...modifiers.not_working_days_from_regime.dayOfWeek ] },
    absence_day_start: typeof selectedDays?.from === 'string' ? new Date(selectedDays?.from) : selectedDays?.from,
    absence_day_end: typeof selectedDays?.to === 'string' ? new Date(selectedDays?.to) : selectedDays?.to,
  };

  return (
    <DayPicker
      mode='range'
      locale={fr}
      showOutsideDays
      canChangeMonth={false}
      month={month}
      className="custom_day_picker"
      selected={selectedDays}
      onSelect={onSelect}
      disableNavigation
      modifiers={{...defaultModifiers, ...modifiers}}
      modifiersClassNames={{
        absence_day_start: "absence_day_start",
        absence_day_end: "absence_day_end",
        ...modifiersClassNames
      }}
    />
  )
}
